module.exports = __webpack_public_path__ + "img/Pic_Services-8.c656e3bb.jpg";